const TARGET_TICKS = 60;
const MIN_SPACING = 25;
const MAX_SPACING = 400;
const MIN_TICKS = 3;
const MAX_TICKS = 300;
const TICK_HALF_RATIO = 2 / 3;
const MIN_RING_LENGTH = 1;

function getTickSpacing(ringLength) {
  let spacing = Math.min(Math.max(ringLength / TARGET_TICKS, MIN_SPACING), MAX_SPACING);

  if (ringLength / spacing > MAX_TICKS) {
    spacing = ringLength / MAX_TICKS;
  }
  if (ringLength / spacing < MIN_TICKS) {
    spacing = ringLength / MIN_TICKS;
  }

  return spacing;
}

function buildTickPathsForRing(vertices, spacing, half) {
  const paths = [];
  let cursor = spacing / 2;

  for (let i = 0; i < vertices.length - 1; i++) {
    const [ax, ay] = vertices[i];
    const [bx, by] = vertices[i + 1];
    const dx = bx - ax;
    const dy = by - ay;
    const len = Math.hypot(dx, dy);

    if (len === 0) continue;

    const nx = -dy / len;
    const ny = dx / len;

    while (cursor <= len) {
      const t = cursor / len;
      const px = ax + dx * t;
      const py = ay + dy * t;

      paths.push([
        [px - half * nx, py - half * ny],
        [px + half * nx, py + half * ny],
      ]);
      cursor += spacing;
    }

    cursor -= len;
  }

  return paths;
}

export function buildTickPaths(geometry) {
  const paths = [];

  for (const ring of geometry.rings) {
    const vertices = [];

    for (const vertex of ring) {
      const previous = vertices[vertices.length - 1];
      if (!previous || Math.hypot(vertex[0] - previous[0], vertex[1] - previous[1]) >= 0.01) {
        vertices.push(vertex);
      }
    }

    if (vertices.length > 1) {
      const first = vertices[0];
      const last = vertices[vertices.length - 1];
      if (first[0] !== last[0] || first[1] !== last[1]) {
        vertices.push(first);
      }
    }

    if (vertices.length < 4) continue;

    let ringLength = 0;
    for (let i = 0; i < vertices.length - 1; i++) {
      ringLength += Math.hypot(vertices[i + 1][0] - vertices[i][0], vertices[i + 1][1] - vertices[i][1]);
    }

    if (ringLength < MIN_RING_LENGTH) continue;

    const spacing = getTickSpacing(ringLength);
    const half = spacing * TICK_HALF_RATIO;

    paths.push(...buildTickPathsForRing(vertices, spacing, half));
  }

  return paths;
}

export function perimetroOutlinePolygon3D(colorFinal, pattern) {
  const outline = {
    color: colorFinal,
    size: 3,
  };

  if (pattern) {
    outline.pattern = pattern;
    outline.patternCap = 'butt';
  }

  return {
    type: 'polygon-3d',
    symbolLayers: [
      {
        type: 'fill',
        material: { color: [0, 0, 0, 0] },
        outline,
      },
    ],
  };
}


